<template>
  <div class="bg-gray-900 flex h-full items-center justify-center">
    <UCard class="w-md dark:bg-gray-800">
      <div class="logo-section text-center py-2">
        <img
          v-show="colorMode.value == 'light'"
          src="/img/settler-exchange-logo B light bg.png"
          class="w-[80%] max-w-[250px] m-auto"
        >
        <img
          v-show="colorMode.value == 'dark'"
          src="/img/settler-exchange-logo B dark bg.png"
          class="w-[80%] max-w-[250px] m-auto"
        >
      </div>

      <UAlert
        v-show="errorMessage"
        class="mb-4"
        variant="subtle"
        color="error"
        title="Error logging in"
        :description="errorMessage"
      />

      <UForm
        :schema="schema"
        :state="formData"
        class="space-y-4"
        @submit="logIn"
      >
        <UFormField label="Email" name="email">
          <UInput
            v-model="formData.email"
            icon="i-lucide-user"
            size="xl"
            class="w-full"
            autofocus
          />
        </UFormField>

        <UFormField label="Password" name="password">
          <UInput
            v-model="formData.password"
            icon="i-lucide-lock"
            class="w-full"
            size="xl"
            placeholder="Password"
            :type="showPassword ? 'text' : 'password'"
            :ui="{ trailing: 'pe-1' }"
          >
            <template #trailing>
              <UButton
                color="neutral"
                variant="link"
                size="sm"
                :icon="showPassword ? 'i-lucide-eye-off' : 'i-lucide-eye'"
                :aria-label="showPassword ? 'Hide password' : 'Show password'"
                :aria-pressed="showPassword"
                aria-controls="password"
                @click="showPassword = !showPassword"
              />
            </template>
          </UInput>
        </UFormField>

        <UButton type="submit" class="w-full justify-center mt-2" size="xl"
          >Log in</UButton
        >
      </UForm>

      <USeparator orientation="horizontal" label="other options" class="mt-5" />

      <UButton
        class="w-full mt-5 p-3 justify-center"
        variant="outline"
        label="Sign in with Google"
        icon="i-fa-google"
        color="neutral"
        @click="logInWithGoogle"
      />

      <div class="text-center pt-2">
        Don't have an account yet?
        <UButton to="/register" variant="link">Register</UButton>
      </div>
    </UCard>
  </div>
</template>

<script lang="ts" setup>
import * as z from "zod";
import type { FormSubmitEvent } from "@nuxt/ui";

const showPassword = ref(false);
const errorMessage = ref("");
const supabase = useSupabaseClient();
const colorMode = useColorMode();

const schema = z.object({
  email: z.string().email("Invalid email"),
  password: z.string().min(8, "Must be at least 8 characters"),
});

type Schema = z.output<typeof schema>;

const formData = ref<Partial<Schema>>({
  email: undefined,
  password: undefined,
});

async function logIn(event: FormSubmitEvent<Schema>) {
  console.log(event.data);
  try {
    const { error } = await supabase.auth.signInWithPassword({
      email: event.data.email,
      password: event.data.password,
    });

    if (error) throw error;

    //all good, lets go
    navigateTo("/game/setup");
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : String(error);
  }
}

function logInWithGoogle() {
  const config = useRuntimeConfig();
  const baseUrl = config.public.baseURL;

  console.log(baseUrl);
  
  supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: `${baseUrl}/auth/confirm`,
      //redirectTo: 'http://localhost:3000/auth/confirm',
    },
  });
}
</script>

<style></style>
